import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterIcon',
  pure: false
})
export class FilterPipe implements PipeTransform {

  transform(items: any[], filter: any): any {
    // console.log(filter);
    // console.log(items);
    if (!items) {
      console.log('a');
      return [];
   }
    if (!filter || filter.length == 0) {
        console.log('b');
        return items;
      }
      else if (filter || filter.length != 0) {
        console.log(items.filter(item => item.name.toLowerCase().indexOf(filter.name)!= -1));
        return items.filter(item => item.name.toLowerCase().indexOf(filter.name) != -1);
      }
    // else {
    // }!= -1
  // filter items array, items which match and return true will be
  // kept, false will be filtered out
  }

}
